export default "__VITE_ASSET__BxewMgql__"